import { PRIVACY_POLICY_VERSION } from '../config.ts';
import { ApiError, apiRequest } from './client.ts';

export interface User {
  id: string;
  email: string;
  username: string;
  locale: string;
}

export interface RegisterPayload {
  email: string;
  username: string;
  password: string;
  locale: string;
}

export async function register(payload: RegisterPayload): Promise<User> {
  const { user } = await apiRequest<{ user: User }>('/auth/register', {
    method: 'POST',
    // RGPD: el consentimiento es explícito y el backend solo acepta `true`. Se manda
    // desde aquí porque el formulario ya ha exigido marcar la casilla; enviarlo fijo
    // sin esa comprobación sería premarcarla por la puerta de atrás.
    body: { ...payload, consent: true, privacy_policy_version: PRIVACY_POLICY_VERSION },
  });
  return user;
}

export async function login(email: string, password: string): Promise<User> {
  const { user } = await apiRequest<{ user: User }>('/auth/login', {
    method: 'POST',
    body: { email, password },
    // El 401 aquí significa "credenciales incorrectas", no "sesión caducada".
    skipAuthRedirect: true,
  });
  return user;
}

export async function logout(): Promise<void> {
  await apiRequest<void>('/auth/logout', { method: 'POST' });
}

/**
 * ¿Hay sesión? Devuelve null en vez de lanzar cuando no la hay: no tenerla es un estado
 * normal de la aplicación, no un error.
 */
export async function fetchCurrentUser(signal?: AbortSignal): Promise<User | null> {
  try {
    const { user } = await apiRequest<{ user: User }>('/auth/me', {
      skipAuthRedirect: true,
      ...(signal ? { signal } : {}),
    });
    return user;
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return null;
    throw error;
  }
}
